import { Component,Output, Input, EventEmitter, OnInit } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';
import * as codigoInstituciones from '../../localDataJson/codigoinstituciones.json';
import swal from 'sweetalert2';
import * as moment from 'moment';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {CommonFunctions} from '../../utils/common-functions';
import { AlertService } from "../../services/alert.service";
@Component({
  selector: 'app-gestiones-productos-general',
  templateUrl: './gestiones-productos-general.component.html',
  styleUrls: ['./gestiones-productos-general.component.scss']
})
export class GestionesProductosGeneralComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService
  productosCliente = []
  cuentasCliente=[]
  tieneTarjeta = 'S';
  tieneCreditos = 'S';
  tieneProductosE = 'S';
  clientData: any = {};
  instituciones: any = (codigoInstituciones as any).default

  constructor(private ngxUiLoaderService: NgxUiLoaderService,
    private alertService: AlertService) {
    setTimeout(() => {
     /* let datos = {
        ...this.clienteserviceParam.getProductosCliente()
      }*/
      if (this.clienteserviceParam.flowType === 'DEBTOR') {
        this.setDataproductos(this.clienteserviceParam.productosCliente);
      } else {
        this.setDataproductos(this.clienteserviceParam.productosCodeudor);
      }
      if (this.clienteserviceParam.consultaFlag) {
        this.setDataCuentas()
      }
    }, 500);
  }

  ngOnInit(): void {
    this.clientData =  this.clienteserviceParam.flowType === 'DEBTOR'
      ? this.clienteserviceParam.datosCliente : this.clienteserviceParam.datosCodeudor;
  }

  validateCoDebtor() {
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    const response = CommonFunctions.validateIndirectCreditsCoDebtor(
      this.clienteserviceParam.productosCliente.internoBantrab,
      this.clienteserviceParam.productosCodeudor.internoBantrab,
      this.clienteserviceParam.datosPorductosClientes,
    );

    this.clienteserviceParam.commonCredits = response.commonCredits;

    if (response.commonCredits
      && response.commonCredits.length > 0
      && !response.isCommonCreditConsolidated) {
      this.selecttab.emit(10);
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      this.clienteserviceParam.datosCliente.needCoDebtor = false;
      this.clienteserviceParam.solicitarOferta().then(result => {
        this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          if (result == "R") {
            this.selecttab.emit(11);
          } else if (result == "SD") {
            this.showNotificationsinoferta(
              "No se han obtenido ofertas",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          } else if (result == "A") {
            if (this.clienteserviceParam.ofertasComerciales.ofertaComercial.length == 2 && this.clienteserviceParam.ofertasComerciales.ofertaComercial[0].bienestarMixAndMatchFlg==1) {
              this.clienteserviceParam.ofertaseleccionada = 0
              this.clienteserviceParam.ofertamym=0
              this.selecttab.emit(13)
            } else {
              this.selecttab.emit(12)
            }
          } else {
            this.showNotificationsinoferta(
              "Ha ocurrido un error",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          }
        })
        .catch((error) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          if (error.codigoError && error.codigoError == "1003") {
            this.showNotificationsinoferta(
              "Aviso",
              error.mensajeTecnicoAPI
            );
          }
          else if (error.codigoError!="0") {
            this.showNotificationError(
              "Aviso",
              'Ha ocurrido un error, intentelo más tarde. Código de error: '+error.codigoError
            );
          }
          else if (error == "errorguardado") {
            this.showNotificationsinoferta(
              "Ha ocurrido un error",
              "No se ha podido guardar la precalificación."
            );
          } else{
            this.showNotificationError(
              "Alerta",
              "No se ha podido establecer conexión con el servidor, intentelo de nuevo."
            );
          }
        });
    }
  }

  showNotificationsinoferta(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
        this.selecttab.emit(0);
      });
  }
  showNotificationError(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
      });
  }

  setDataproductos(datos) {
    var dataProductos = [];
    var buroInternoCredito = [];
    var DatosTarjeta = [];
    if (datos.sircRuta12 == null) {
      var dataProductos = [];
      var buroInternoCredito = [];
      var DatosTarjeta = [];
    } else {
      datos.sircRuta12.mensaje.contenido.endeudaDirecto.forEach(element => {
        dataProductos.push(Object.assign({}, element))
      });
    }
    if(datos.internoBantrab.tarjetas!=null){
      datos.internoBantrab.tarjetas.forEach(element => {
        DatosTarjeta.push(Object.assign({}, element))
      });
    }
    if(datos.internoBantrab.creditos!=null){
      datos.internoBantrab.creditos.forEach(element => {
        buroInternoCredito.push(Object.assign({}, element))
      });
    }
    var contador = 0;
    var vanderaProductosE = false;
    let tarjetas=[]
    DatosTarjeta.forEach(element => {
      if (tarjetas.find(i => i.noTarjeta == element.noTarjeta) != null) {
        let aux = tarjetas.find(i => i.noTarjeta == element.noTarjeta)
        if (aux.limiteCredito < element.limiteCredito) {
          aux.limiteCredito=element.limiteCredito
        }
        aux.pagoMinimo=Number(aux.pagoMinimo)+Number(element.pagoMinimo)
        aux.saldo=Number(aux.saldo)+Number(element.saldo)
      } else {
        tarjetas.push(element)
      }
    })
    DatosTarjeta=tarjetas
    for (var i = 0; i < dataProductos.length; i++) {
      if (dataProductos[i].nomEntidad != "BANCO DE LOS TRABAJADORES") {
        contador = contador + i;
        if ((dataProductos[i].codTipoActivo == "5" || dataProductos[i].codTipoActivo == "6") && dataProductos[i].descMoneda == 'Quetzal') {
          let tcDolares = dataProductos.find(element => element.descMoneda == 'Dolar Estadounidense' && element.nomEntidad == dataProductos[i].nomEntidad && element.fecconce == dataProductos[i].fecconce && element.capitalOrig == dataProductos[i].capitalOrig)
          if (tcDolares) {
            var totalSaldo = parseFloat(dataProductos[i].saldo) + parseFloat(tcDolares.saldo)
            dataProductos[i].saldo = totalSaldo.toString();
          }
          var datostc = {
            "id": i,
            "nomEntidad": dataProductos[i].nomEntidad,
            "CodEntidad": " ",
            "codEstado": dataProductos[i].codEstado,
            "descEstado": dataProductos[i].descEstado,
            "codTipoActivo": dataProductos[i].codTipoActivo,
            "descTipoActivo": dataProductos[i].descTipoActivo,
            "codTipoGara": dataProductos[i].codTipoGara,
            "descTipoGara": dataProductos[i].descTipoGara,
            "categoria": dataProductos[i].categoria,
            "codMoneda": dataProductos[i].codMoneda,
            "descMoneda": dataProductos[i].descMoneda,
            "capitalOrig": dataProductos[i].capitalOrig,
            "saldo": dataProductos[i].saldo,
            "fecconce": dataProductos[i].fecconce,
            "fecvence": dataProductos[i].fecvence,
            "fpagocap": dataProductos[i].fpagocap,
            "fpagoint": dataProductos[i].fpagoint,
            "situacion": dataProductos[i].situacion,
            "vinculo": dataProductos[i].vinculo,
            "persona": dataProductos[i].persona,
            "permitidoConsolidar": false,
            "CONSOLIDA": false
          }
          this.productosCliente.push(datostc)
        } else {
          if (!(dataProductos[i].codTipoActivo == "5" || dataProductos[i].codTipoActivo == "6")) {
            var dastos1 = {
              "id": i,
              "nomEntidad": dataProductos[i].nomEntidad,
              "CodEntidad": " ",
              "codEstado": dataProductos[i].codEstado,
              "descEstado": dataProductos[i].descEstado,
              "codTipoActivo": dataProductos[i].codTipoActivo,
              "descTipoActivo": dataProductos[i].descTipoActivo,
              "codTipoGara": dataProductos[i].codTipoGara,
              "descTipoGara": dataProductos[i].descTipoGara,
              "categoria": dataProductos[i].categoria,
              "codMoneda": dataProductos[i].codMoneda,
              "descMoneda": dataProductos[i].descMoneda,
              "capitalOrig": dataProductos[i].capitalOrig,
              "saldo": dataProductos[i].saldo,
              "DIRECTO_INDIRECTO": "DIRECTO",
              "fecconce": dataProductos[i].fecconce,
              "fecvence": dataProductos[i].fecvence,
              "fpagocap": dataProductos[i].fpagocap,
              "fpagoint": dataProductos[i].fpagoint,
              "situacion": dataProductos[i].situacion,
              "vinculo": dataProductos[i].vinculo,
              "persona": dataProductos[i].persona,
              "permitidoConsolidar": false,
              "CONSOLIDA": false
            }
            this.productosCliente.push(dastos1);
          }
        }
        this.tieneProductosE = 'S';
        vanderaProductosE = true;
      } else {
        if (vanderaProductosE == false) {
          this.tieneProductosE = 'N';
        }

      }
    }
    for (var j = 0; j < buroInternoCredito.length; j++) {
      if (buroInternoCredito[j].mensaje != "NO TIENE CREDITOS") {
        var dastoss = {
          "id": contador + j,
          "nomEntidad": "BANCO DE LOS TRABAJADORES",
          "CodEntidad": "BANCO DE LOS TRABAJADORES",
          "codEstado": "",
          "descEstado": "",
          "codTipoActivo": "",
          "descTipoActivo": "Prestamos",
          "codTipoGara": "",
          "descTipoGara": "",
          "categoria": "",
          "codMoneda": "",
          "descMoneda": "",
          "descripcionTipoCredito": buroInternoCredito[j].descripcionTipoCredito,
          "capitalOrig": buroInternoCredito[j].capitalOriginal,
          "saldo": buroInternoCredito[j].saldo,
          "CUOTA": buroInternoCredito[j].cuota,
          "NO_CREDITO": buroInternoCredito[j].noCredito,
          "DIRECTO_INDIRECTO": buroInternoCredito[j].directoIndirecto,
          "DESCUENTO_CODEUDOR": buroInternoCredito[j].descuentoCodeudor,
          "DESCRIPCION": buroInternoCredito[j].descripcion,
          "ABREV_ESTADO": buroInternoCredito[j].abrevEstado,
          "TIPO_CREDITO": buroInternoCredito[j].tipoCredito,
          "MONTO_PAGADO_PRINCIPAL": buroInternoCredito[j].montoPagadoPrincipal,
          "COUTAS_PAGADAS": buroInternoCredito[j].cuotasPagadas,
          "C_POR_PAGAR": buroInternoCredito[j].cPorPagar,
          "SALDO_VENCIDO": buroInternoCredito[j].saldoVencido,
          "fecconce": buroInternoCredito[j].fConsecion,
          "fecvence": buroInternoCredito[j].fVencimiento,
          "fpagocap": "",
          "fpagoint": "",
          "situacion": "",
          "vinculo": "",
          "persona": "",
          "endeudaDirecto_Id": "",
          "permitidoConsolidar": false,
          "CONSOLIDA": false
        };
        this.productosCliente.push(dastoss);
      } else {
        this.tieneCreditos = 'N';
      }
    }
    for (var j = 0; j < DatosTarjeta.length; j++) {
      if (DatosTarjeta[j].mensaje != "NO TIENE TARJETAS" && DatosTarjeta[j].mensaje != "NO EXISTE EN TC") {
        var dastos2 = {
          "nomEntidad": "BANCO DE LOS TRABAJADORES",
          "CodEntidad": "BANCO DE LOS TRABAJADORES",
          "descTipoActivo": "Tarjeta de Credito",
          "COD_TIPO_TARJETA": DatosTarjeta[j].codTipoTarjeta,
          "DIAS_MORA": DatosTarjeta[j].diasMora,
          // "Datos_Id":DatosTarjeta[j].Datos_Id,
          "DIRECTO_INDIRECTO": "DIRECTO",
          "ESTADO": DatosTarjeta[j].estado,
          "EXTRAFINANCIAMIENTO": DatosTarjeta[j].extrafinanciamiento,
          "FECHA_ACTIVACION": DatosTarjeta[j].fechaActivacion,
          "fecconce": DatosTarjeta[j].fechaConsesion,
          "limiteCredito": DatosTarjeta[j].limiteCredito,
          "capitalOrig": DatosTarjeta[j].limiteCredito,
          "MENSAJE": DatosTarjeta[j].mensaje,
          "NO_TARJETA": DatosTarjeta[j].noTarjeta,
          "PAGO_MINIMO": DatosTarjeta[j].pagoMinimo,
          "saldo": DatosTarjeta[j].saldo,
          "TIPO_TARJETA": DatosTarjeta[j].tipoTarjeta,
          "permitidoConsolidar": false,
          "CONSOLIDA": false
        }
        this.productosCliente.push(dastos2);
      } else {
        this.tieneTarjeta = 'N';
      }
    }

    if (DatosTarjeta.length === 0) {
      this.tieneTarjeta = 'N';
    }

    if (dataProductos.length === 0) {
      this.tieneProductosE = 'N';
    }

    if (buroInternoCredito.length === 0) {
      this.tieneCreditos = 'N';
    }

    this.asignacionCodigoBanco();
    this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
  }
  asignacionCodigoBanco() {
    for (var i = 0; i < this.productosCliente.length; i++) {
      for (var j = 0; j < this.instituciones.length; j++) {
        if (this.productosCliente[i].nomEntidad == this.instituciones[j].nomEntidad) {
          this.productosCliente[i].CodEntidad = this.instituciones[j].Codigo_Intitución;
        }
      }
    }
  }
  selectProducto(producto) {
    console.log(producto);
    this.clienteserviceParam.productoDetalleSelected = producto
    this.selecttab.emit(17)//detalle producto
  }
  setDataCuentas() {
    this.clienteserviceParam.getCuentasCliente().then(result => {
      this.cuentasCliente=result.data
    }).catch(error => [
      this.alertService.confirmation('Alerta','No se encontraron registros de las cuentas del cliente.')
    ])
  }
  goBack() {
    if (this.clienteserviceParam.consultaFlag) {
      this.selecttab.emit(14)
    } else {
      this.selecttab.emit(9) 
    }
  }
  consolidarDeudas() {
    this.selecttab.emit(10)
  }
  solicitudOfertaTc() {
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    this.clienteserviceParam.solicitarOferta().then(result=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      if(result=='A'){
        this.selecttab.emit(18)
      }else{
        this.selecttab.emit(11)
      }
    }).catch(error=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.showNotificationError('Alerta', 'Un error ha ocurrido, intente de nuevo.')
    })
  }
  
}
